import { cloudCode } from ".";

type updateCameraStationSettingsParams = {
  name?: string;
  color?: CameraColorId;
  icon?: CameraIconId;
  settings?: ServerCameraSettings;
  supportedFeatures?: SupportedFeatures;
};

export function updateCameraStationSettings({
  xmppLogin,
  name,
  color,
  icon,
  settings,
  supportedFeatures
}: updateCameraStationSettingsParams & {
  xmppLogin: string;
  useCases?: string;
}): Promise<ParseCameraDevice> {
  return cloudCode.run("updateCameraStationSettings", {
    xmppLogin,
    name,
    color,
    icon,
    settings: JSON.stringify(settings || {}),
    supportedFeatures: supportedFeatures ? JSON.stringify(supportedFeatures) : undefined
  });
}

// Could be moved to the camera module
type UpdateCameraStationSupportedFeaturesParams = {
  xmppLogin: string;
  supportedFeatures: SupportedFeatures;
};

export function updateCameraStationSupportedFeatures({
  xmppLogin,
  supportedFeatures
}: UpdateCameraStationSupportedFeaturesParams): Promise<ParseCameraDevice> {
  return cloudCode.run("updateCameraStationSupportedFeatures", {
    xmppLogin,
    supportedFeatures
  });
}
